export default __webpack_public_path__ + "static/media/644.e102181a.png";